import localeConfig from './locales.json';

export const { supportedLocales, defaultLocale } = localeConfig;
const { defaultLocaleByLanguage, localeOverrides } = localeConfig;

const resolveLocale = (value) => {
  let locale;
  try {
    locale = new Intl.Locale(value.trim().replaceAll('_', '-'));
  } catch {
    return null;
  }

  const candidates = [locale.baseName];
  if (locale.language === 'zh') {
    if (locale.script === 'Hant') candidates.push('zh-TW');
    else if (locale.script === 'Hans') candidates.push('zh-CN');
  }
  if (locale.region) candidates.push(`${locale.language}-${locale.region}`);

  for (const candidate of candidates) {
    if (supportedLocales.includes(candidate)) return candidate;
    if (localeOverrides[candidate]) return localeOverrides[candidate];
  }

  return (
    defaultLocaleByLanguage[locale.language] || (supportedLocales.includes(locale.language) ? locale.language : null)
  );
};

// Keep resolution order and regional defaults aligned with the API's src/i18n.js.
export const getSupportedLocale = (locales) => {
  for (const locale of locales) {
    const resolved = resolveLocale(locale);
    if (resolved) {
      return resolved;
    }
  }
  return defaultLocale;
};

const dayjsLocales = {
  'es-419': 'es',
  'es-ES': 'es',
  'pt-BR': 'pt-br',
  'pt-PT': 'pt',
  'zh-CN': 'zh-cn',
  'zh-TW': 'zh-tw',
};

export const getDayjsLocale = (locale) => dayjsLocales[locale] || locale;

const stripeLocales = {
  'pt-PT': 'pt',
  'zh-CN': 'zh',
};

export const getStripeLocale = (locale) => stripeLocales[locale] || locale;
